import { render, staticRenderFns } from "./BiddingEdit.vue?vue&type=template&id=042c3e1f&"
import script from "./BiddingEdit.vue?vue&type=script&lang=js&"
export * from "./BiddingEdit.vue?vue&type=script&lang=js&"
import style0 from "./BiddingEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports